import styled from 'styled-components';
import { config } from '../../../../../../../components/dashboards/config';

export const FilterContainerStyle = styled.div`
  position: absolute;
  right: 0px;
  top: 0px;
  padding-left: 14px;
  background: ${config.DASHBOARD_BACKGROUND};
  display: flex;
  z-index: 1;

  .btn-icon {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .ant-btn-icon {
      margin-left: 0px;
      margin-right: 0px;
    }
    
    span {
      margin-left: 0px;
    }
  }
`;
